import { ListItem, ListItemButton, Stack, Typography } from '@mui/material';
import React from 'react';
import { Link } from 'react-router-dom';

import colors from '../../../constants/colors';

export interface ListIconsProps {
  Component: React.ComponentType;
  text: string;
  extra?: string;
  showText?: boolean;
  onClick?: () => void;
  arrow?: React.ReactElement<any>;
  isExpanded?: boolean;
  path?: string;
  previousPage?: string;
}

const ListIcons = ({
  Component,
  text,
  extra,
  showText = true,
  onClick,
  arrow,
  path,
  previousPage,
  isExpanded,
}: ListIconsProps) => (
  <ListItem>
    <ListItemButton
      component={path ? Link : 'button'}
      disableRipple
      onClick={onClick}
      aria-label={text}
      aria-expanded={!path ? !!isExpanded : undefined}
      {...(path ? { to: path } : {})}
      {...(path === '/change-password' ? { state: previousPage } : {})}
    >
      <Stack sx={{ mr: 1.5, minWidth: 'auto' }}>
        <Component />
      </Stack>
      {showText && (
        <Stack
          direction="row"
          sx={{
            justifyContent: 'space-between',
            width: 1,
            alignItems: 'center',
          }}
        >
          <Typography
            sx={{
              fontSize: { mobile: 16, tablet: 18 },
              lineHeight: '19px',
              color: colors.csaaMid,
            }}
          >
            {text}
          </Typography>
          {arrow}
          {extra && (
            <Typography
              sx={{
                fontFamily: 'Cabin',
                fontKerning: 'normal',
                fontSize: 14,
                lineHeight: '16px',
                color: colors.csaaMid,
                backgroundColor: colors.csaaNeutral,
                fontWeight: 500,
                py: 0.5,
                px: { mobile: 0.5, tablet: 1 },
                borderRadius: 1,
                whiteSpace: 'nowrap',
              }}
            >
              {extra}
            </Typography>
          )}
        </Stack>
      )}
    </ListItemButton>
  </ListItem>
);

export default ListIcons;
